import { ORGANIZATION_USER_ROLE_COLORS } from "lib/constants";
import { colorHash } from "lib/utils";
import clsx from "clsx";
import _ from "lodash";

export default function OrganizationItem({ orgUser, onSelect, selectedUser }) {
  const { user } = orgUser;
  const roleColor = ORGANIZATION_USER_ROLE_COLORS[user?.role?.name] || {
    textColor: "text-gray-700",
    bgColor: "bg-gray-100",
  };
  const isSelected = selectedUser?.user?.id === user.id;
  console.log("isSelected", isSelected, selectedUser, user);
  return (
    <div
      className={clsx(
        "p-4 border-b border-gray-200 cursor-pointer",
        isSelected ? "bg-blue-200" : "hover:bg-blue-100",
      )}
      onClick={() => {
        onSelect(orgUser);
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex">
          <div
            className="flex items-center justify-center w-10 h-10 mr-3 text-white  rounded-full"
            style={{ backgroundColor: colorHash.hex(user.email || "") }}
          >
            <span className="text-lg font-semibold">
              {(user.firstName || user.email).charAt(0).toUpperCase()}
            </span>
          </div>
          <div>
            <p className="font-semibold overflow-hidden max-w-xs">{`${user.firstName} ${user.lastName}`}</p>
            <p className="text-sm text-gray-500 overflow-hidden max-w-xs">
              {user.email}
            </p>
            <p className="text-sm text-gray-500 overflow-hidden max-w-xs">
              {user.phoneNumber}
            </p>
          </div>
        </div>
        <div
          className={`ml-2 text-sm ${roleColor.textColor} ${roleColor.bgColor} px-2 py-1 rounded text-nowrap`}
        >
          {_.startCase(user?.role?.name)}
        </div>
      </div>
    </div>
  );
}
